import { render, staticRenderFns } from "./ForeignerBeneficiaryForm.vue?vue&type=template&id=12c787f1&"
import script from "./ForeignerBeneficiaryForm.vue?vue&type=script&lang=js&"
export * from "./ForeignerBeneficiaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports